import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {useFormApi} from "../context/ApiContext.tsx";
import {ReportForm} from "../api/ApiTypes.ts";
import {SUBMIT_MODE} from "../components/dynamicforms/dyanimcFormUtil.tsx";
import {ReportFormLayout} from "../components/dynamicforms/ReportFormLayout.tsx";

export interface ReportFormPageProps {
    mode: SUBMIT_MODE;
}

export const ReportFormPage: React.FC<ReportFormPageProps> = ({
                                                                  mode = SUBMIT_MODE.READ_ONLY
                                                              }) => {
    console.log("Report Form Page Rendered in ", mode)
    const { orderId } = useParams<{ orderId: string }>();
    const formApi = useFormApi();

    // State for form data
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const [reportForm, setReportForm] = useState<ReportForm | null>(null);

    // Load report form data - using useEffect with proper dependency array
    useEffect(() => {
        if (!orderId) return;

        const fetchReportData = async () => {
            setIsLoading(true);
            setError(null);

            try {
                // Fetch the report form schema
                const form = await formApi.getReportForm(Number(orderId), mode);
                console.log("Order: ", orderId, " Schema: ", form);
                // Store report details
                setReportForm(form);
            } catch (err) {
                console.error("Error loading report form:", err);
                setError("Failed to load the report form. Please try again later.");
            } finally {
                setIsLoading(false);
            }
        };

        fetchReportData();
    }, [orderId, mode]); // Add proper dependencies


    // Show loading state
    if (isLoading) {
        return (
            <div className="flex justify-center items-center h-64">
                <div className="text-center">
                    <div className="inline-block animate-spin rounded-full h-8 w-8 border-4 border-slate-300 border-t-blue-600"></div>
                    <p className="mt-2 text-slate-600">Loading form...</p>
                </div>
            </div>
        );
    }

    // Show error state
    if (error || !reportForm) {
        return (
            <div className="bg-red-50 p-6 rounded-lg border border-red-200 text-center">
                <svg className="mx-auto h-12 w-12 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                </svg>
                <h3 className="mt-3 text-lg font-medium text-red-800">Failed to load form</h3>
                <p className="mt-2 text-red-700">{error || "Unable to display the form. Please try again later."}</p>
                <button
                    onClick={() => window.location.reload()}
                    className="mt-4 px-4 py-2 bg-red-600 text-white rounded-md text-sm font-medium hover:bg-red-700 transition-colors"
                >
                    Retry
                </button>
            </div>
        );
    }

    // Render the form - Prevent excessive re-renders by checking reportForm is available
    return (
        <ReportFormLayout
            reportForm={reportForm}
            mode={mode}
        />
    );
};